/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import {
  ConsoleInstanceBaseHostingType,
  ConsoleInstanceMatrixEnvironmentType,
  EntityConsoleConnectInstance,
  EntityConsoleFormInstance,
  EntityConsoleFunnelbackInstance,
  EntityConsoleInstance,
  EntityConsoleMatrixInstance,
} from 'apps/console-core/src/Services/console';
import { ProductInstanceListItem } from '../ProductInstanceList.defs';
import { ProductInstanceKey } from '../ProductInstanceList.enum';

/**
 * Convert instances into list items for `<ProductInstanceList />`.
 * @param instances Instance list from console.
 * @param type The key for instances being listed.
 * @returns A converted list of instances.
 */
export const convertForInstanceList = (
  instances: Array<EntityConsoleInstance>,
  type: ProductInstanceKey,
): Array<ProductInstanceListItem> => {
  return instances.map((instance: EntityConsoleInstance) => {
    let environment: ConsoleInstanceMatrixEnvironmentType | null = null;
    let hostingType: ConsoleInstanceBaseHostingType | null = null;
    let url = ``;
    let displayUrl: string | undefined;

    if (type === ProductInstanceKey.connect) {
      const connectInstance = instance as EntityConsoleConnectInstance;
      displayUrl = connectInstance.connectWorkspaceUrl;
      url = connectInstance.connectWorkspaceUrlSso;
    }

    if (type === ProductInstanceKey.form) {
      const formInstance = instance as EntityConsoleFormInstance;
      displayUrl = formInstance.formUrl;
      url = formInstance.formUrlSso;
    }

    if (type === ProductInstanceKey.funnelback) {
      const fbAdminInstance = instance as EntityConsoleFunnelbackInstance;
      hostingType = fbAdminInstance.hostingType;
      url = fbAdminInstance.adminUrl;
    }

    if (type === ProductInstanceKey.matrix) {
      const matrixInstance = instance as EntityConsoleMatrixInstance;
      url = matrixInstance.adminUrl;
      hostingType = matrixInstance.hostingType;
      environment = matrixInstance.environment;
    }

    const listItem = {
      ...instance,
      displayUrl,
      environment,
      hostingType,
      url,
    } as ProductInstanceListItem;

    return listItem;
  });
};
